import { render, staticRenderFns } from "./studydurationchart.vue?vue&type=template&id=135ee205&scoped=true"
import script from "./studydurationchart.vue?vue&type=script&lang=js"
export * from "./studydurationchart.vue?vue&type=script&lang=js"
import style0 from "./studydurationchart.vue?vue&type=style&index=0&id=135ee205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ee205",
  null
  
)

export default component.exports